export default {
    directives: {
        imgSrc: ["gift-cards.sinteks.com"]
    },
    urls: {
        site: 'gift-cards.sinteks.com'
    }
}
